import { keepPreviousData } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';
import {
  DividendFrequency,
  DividendPayoutStatus,
  DividendPeriodFilter,
  DividendSortOrder,
} from './dividend.types';

export type StakeholderPayoutRow = {
  approvalDate: null | string;
  dividendPerShare: null | number;
  frequency: DividendFrequency;
  payoutDate: null | string;
  payoutId: string;
  payoutName: string;
  periodIndex: null | number;
  shareClassId: null | string;
  shareClassName: null | string;
  shares: null | number;
  stakeholderId: string;
  stakeholderName: string;
  status: DividendPayoutStatus;
  totalAmount: number;
  year: number;
};

type StakeholderRowsResponse = {
  records: StakeholderPayoutRow[];
  totalPages: number;
};

type Props = {
  companyId: string;
  enabled?: boolean;
  period?: DividendPeriodFilter;
  search?: string;
  shareClassId?: string;
  skip?: number;
  sortBy?: string;
  sortOrder?: DividendSortOrder;
  status?: DividendPayoutStatus;
  take?: number;
};

export const useDividendStakeholderRows = ({
  companyId,
  enabled = true,
  period,
  search,
  shareClassId,
  skip,
  sortBy,
  sortOrder,
  status,
  take,
}: Props) => {
  const { data: { records = [], totalPages = 1 } = {}, isLoading } = useAppQuery({
    queryKey: [
      QueryKey.DIVIDEND_STAKEHOLDER_ROWS,
      companyId,
      { period, search, shareClassId, skip, sortBy, sortOrder, status, take },
    ],
    queryFn: () =>
      ApiService.get<StakeholderRowsResponse>(
        { endpoint: BackendRoute.DIVIDENDS_STAKEHOLDER_ROWS },
        { queryParams: { period, search, shareClassId, skip, sortBy, sortOrder, status, take } },
      ),
    enabled: enabled && !!companyId,
    placeholderData: keepPreviousData,
  });

  return { isLoading, records, totalPages };
};
